<template>
  <div id="lang-box">
    <vs-button
      class="small-icon font-weight-light font-12"
      :class="textStyle"
      @click="activePrompt = true"
    >
      Edit Host
    </vs-button>

    <vs-prompt @accept="acceptAlert" @close="close" :active.sync="activePrompt">
      <div>
        <div>Enter the host you want to connect to</div>
        <div>Current Host: <b>{{getCurrentEnvironment}}</b></div>
        <div>Current Websocket: <b>{{getCurrentWs}}</b></div>
        <vs-input class="mt-3" placeholder="Host" v-model="host" />
        <vs-input class="mt-3" placeholder="Websocket" v-model="websocket" />
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: "LanguageSelector",
  data: () => ({
    title: "LanguageSelector",
    host: "",
    websocket: "",
    activePrompt: false,
  }),
  props: {
    textstyle: String,
  },
  methods: {
    ...mapActions('account', ['logout']),
    acceptAlert() {
      this.changeEnvironment();
      this.$vs.notify({
        color: "success",
        title: "Edit Host",
        text: this.$t("Toasts.AcceptButton"),
      });
    },
    close() {},
    changeEnvironment() {
      localStorage.setItem("host", this.host);
      localStorage.setItem("ws", this.websocket);
      localStorage.removeItem("user");
      location.reload(true);
    },
    showLoading() {
      this.$vs.loading({
        container: "#lang-box",
        scale: 0.6,
      });
    },
    handleLogout(){
      this.$vs.loading({
        container: '#navbar-box',
        scale: 0.6
      });
      this.logout().then(function () {
        this.$router.push('/login');
      }.bind(this)).finally(function () {
        this.$vs.loading.close('#navbar-box > .con-vs-loading');
      }.bind(this));
    }
  },
  computed: {
    getCurrentEnvironment() {
      return localStorage.getItem("host") == undefined
        ? localStorage.getItem("originalHost")
        : localStorage.getItem("host");
    },
    getCurrentWs() {
      return localStorage.getItem("ws") == undefined
        ? localStorage.getItem("originalWs")
        : localStorage.getItem("ws");
    },
    textStyle() {
      return this.textstyle ? this.textstyle : "text-dark";
    },
  },
};
</script>
